import styled from 'styled-components'

export const Box = styled.div`
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: white;
    width: 50%;
    border-radius: 3px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, .4);
    padding: 1.5rem;
    margin-top: 3rem;

    h3 {
        text-align: center;
    }

    li {
        line-height: 2;
    }

    .sub {
        line-height: 1.5;
    }

    & .wrong {
        color: red;
    }

    .right {
        color: green;
    }

    @media (max-width: 1090px) {
        width: 60%;
        padding: 1.2rem;

        li {
            font-size: 0.9rem;
        }
    }

    @media (max-width: 900px) {
        top: 1rem;
        bottom: 1rem;
        transform: translate(-50%, 0);
        width: 80%;
        padding: 1rem;

        hr {
            margin: 1rem auto;
        }

        h3 {
            font-size: 1rem;
        }

        li {
            line-height: 1.3;
            font-size: 0.8rem;
        }
    }
`

export const BoxContainer = styled.div`
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, .4);

`